import { render, staticRenderFns } from "./File201.vue?vue&type=template&id=080e4ba8&"
import script from "./File201.vue?vue&type=script&lang=js&"
export * from "./File201.vue?vue&type=script&lang=js&"
import style0 from "./File201.vue?vue&type=style&index=0&id=080e4ba8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports